import {
  searchAll,
  searchMedias,
  searchNews,
} from '../helpers/filters/search-page';
import { search } from './search';

export const KEY_NEWS = 'search-news';
export const KEY_MEDIAS = 'search-media';
export const KEY_ALL = 'search-all';

export const SUGGEST_KEYS = [KEY_NEWS, KEY_MEDIAS, KEY_ALL];

const searchMap = {
  [KEY_NEWS]: search(searchNews),
  [KEY_ALL]: search(searchAll),
  [KEY_MEDIAS]: search(searchMedias),
};

export const suggest = (query) => async (dispatch, getState) =>
  await Promise.all(
    SUGGEST_KEYS.map((key) =>
      searchMap[key](key, 0, { query })(dispatch, getState)
    )
  );

export const FILTER_GLOBAL_SEARCH_KEY = 'global-search-filter';
export const searchGlobal = search(searchAll);
